angular.module('thothApp.directives')
  .directive('contenteditable', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        function read() {
          var text = element.text();
          ngModel.$setViewValue(text);
        }

        ngModel.$render = function() {
          element.html(ngModel.$viewValue || "");
        };

        element.bind('blur keyup change', function() {
          scope.$apply(read);
        });
      }
    };
  });